import React from "react";
import { twMerge, twJoin } from "tailwind-merge";

import { SupText as Text } from "../../../components/UI/Text";
import { toPercent } from "../../../utils/values";

interface IndexCellProps {
  direction: "up" | "down" | "neutral";
  value: number;
  change: string | number;
  className?: string;
}

const STYLES = {
  up: { label: "bg-success-100 text-success-900", value: "bg-success-800" },
  down: { label: "bg-error-75 text-error-900", value: "bg-error-800" },
  neutral: { label: "bg-neutral-100 text-neutral-600", value: "bg-neutral-600" },
};

export function SupIndexCell({ className, value, change, direction }: IndexCellProps) {
  return (
    <span className={twMerge("sup-index-cell inline-flex items-center rounded-full p-.5 pr-2", STYLES[direction].label, className)}>
      <Text as="span" variant="caption" className={twJoin("inline-flex justify-center items-center h-9 w-9 rounded-full text-neutral-50", STYLES[direction].value)}>
        {value}
      </Text>
      <Text as="span" variant="button" className="ml-1 mr-1">
        {typeof change === "string" ? change : toPercent(change)}
      </Text>
    </span>
  );
}
